import React, { createContext, useReducer } from "react";
import { OutboundFilterReducer } from "../reducers/OutboundFilterReducer";
import {
  DEFAULT_SPR_PACKAGE_COUNT,
  DEFAULT_SPR_TIME_LIMIT,
  VISUAL_GRID_VIEW,
  DEFAULT_RC_PACKAGE_COUNT,
  DEFAULT_RC_TIME_LIMIT,
} from "../util/Constants";
import { DEFAULT_CPT_TIME_LIMIT } from "../../outboundSSD/util/Constants";

export const OutboundFilterContext = createContext();

const OutboundFilterContextProvider = (props) => {
  const state = {
    xptNodes: null,
    departure: [],
    driverType: [],
    cluster: [],
    deliveryWindow: [],
    sourceNode: [],
    sprPackageCount: DEFAULT_SPR_PACKAGE_COUNT,
    sprTimeLimit: DEFAULT_SPR_TIME_LIMIT,
    cptTimeLimit: DEFAULT_CPT_TIME_LIMIT,
    shipmentType: [],
    data: {
      xptNodes: [],
      departure: [],
      driverType: [],
      cluster: [],
      deliveryWindow: [],
      shipmentType: [],
      sourceNode: [],
    },
    waveViewType: VISUAL_GRID_VIEW,
    rcPackageCount: DEFAULT_RC_PACKAGE_COUNT,
    rcTimeLimit: DEFAULT_RC_TIME_LIMIT,
  };
  const [viewModelF, dispatchF] = useReducer(OutboundFilterReducer, state);
  return (
    <OutboundFilterContext.Provider value={{ viewModelF, dispatchF }}>
      {props.children}
    </OutboundFilterContext.Provider>
  );
};

export default OutboundFilterContextProvider;



// WEBPACK FOOTER //
// ./src/components/outboundAmzl/context/OutboundFilterContext.js